import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, FormControl, Typography } from "@mui/material";
import { DateTime } from "luxon";
import StarsDatePicker from "../fundamentals/StarsDatePicker.jsx";
import { CONTRACT_TO_SENIORITY_DATES_MAP } from "../../util/constants";
import { TODAY } from "../../util/dateHelper.js";
import { convert_Luxon_To_DateFns } from "../../util/dateTimeFormatter.js";

const SeniorityDates = ({ contract, employeeData, employeeDataErrors, handleEmployeeFieldChange, station }) => {
  return (
    <Box marginTop={2}>
      <Grid container>
        <Typography variant="overline" sx={{ color: "primary.swaBlue", fontWeight: "bold" }}>
          SENIORITY
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        {CONTRACT_TO_SENIORITY_DATES_MAP[contract]?.map((field) => {
          return (
            <Grid container item alignItems="center" key={field.key}>
              <Grid item xs={5} className="bold-text">
                {field.label}
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <StarsDatePicker
                    label={field.label}
                    inputFormat="MM/dd/yyyy"
                    date={employeeData[field.key] ? DateTime.fromFormat(employeeData[field.key], "M/dd/yyyy") : null}
                    onChange={(date) => handleEmployeeFieldChange([field.key], date.toFormat("MM/dd/yyyy"))}
                    dateErrors={(employeeDataErrors && employeeDataErrors[field.key]) || ""}
                    maxDate={convert_Luxon_To_DateFns(TODAY(station))}
                  />
                </FormControl>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

SeniorityDates.propTypes = {
  contract: PropTypes.string.isRequired,
  employeeData: PropTypes.object.isRequired,
  employeeDataErrors: PropTypes.object,
  handleEmployeeFieldChange: PropTypes.func.isRequired,
  station: PropTypes.string.isRequired,
};

export default SeniorityDates;
